import React from 'react'
import { styled } from 'styled-components'
import { ChipsTabsContext } from './ChipsTabsContext'

const ChipsContainer = styled(Flex)`
  width: 100%;
  overflow: hidden;
`

interface ChipsTabsProps {
  value: string | number
  onChange: (newValue: string | number) => void
  children: React.ReactNode
  className?: string
}

function ChipsTabs({ onChange, value, className, children }: ChipsTabsProps) {
  return (
    <ChipsTabsContext.Provider value={{ currentValue: value, onChange }}>
      <ChipsContainer className={className}>{children}</ChipsContainer>
    </ChipsTabsContext.Provider>
  )
}

export default ChipsTabs
